<ng-container *ngIf="this.api.infos.agent">
<!--sidebar : nouveau design "Sceau" par défaut ; ancien sidebar conservé
    intact et réactivable via use_sidebar_sceau = false (home.component.ts).
    Le <c-sidebar> hôte reste ICI (frère direct de .wrapper) dans les deux cas :
    CoreUI calcule le décalage du contenu principal via un sélecteur CSS
    "~ *" qui exige que le sidebar et .wrapper partagent le même parent. -->
<c-sidebar *ngIf="use_sidebar_sceau" #sidebarSceau="cSidebar" [visible]="api.show_sidebar" class="d-print-none sceau" id="sidebarSceau">
  <app-sidebar-sceau [navItems]="navItems_translated"></app-sidebar-sceau>
</c-sidebar>

<c-sidebar *ngIf="!use_sidebar_sceau" #sidebarEmail="cSidebar" [visible]="api.show_sidebar" class="d-print-none" id="sidebarEmail">
  <c-sidebar-brand [brandFull]="{
      src: 'assets/etax/tresor-public-senegal-logo.png',
      width: 90,
      height: 90,
      alt: 'Logo de etax'
    }" [brandNarrow]="{
      src: 'assets/etax/tresor-public-senegal-logo.png',
      width: 46,
      height: 46,
      alt: 'Logo de etax'
    }" href>
  </c-sidebar-brand>
  <c-sidebar-nav [navItems]="navItems_translated">
  </c-sidebar-nav>
  <c-sidebar-toggler toggle="unfoldable" cSidebarToggle="sidebarEmail"></c-sidebar-toggler>
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
  <!--app-header-->
  <app-header-sceau *ngIf="use_sidebar_sceau" class="d-print-none position-sticky top-0 custom_header" position="sticky" sidebarId="sidebarSceau"></app-header-sceau>
  <app-home-header *ngIf="!use_sidebar_sceau" class="d-print-none position-sticky top-0 custom_header bg-light" position="sticky" sidebarId="sidebarEmail"></app-home-header>

  <!--app body-->
  <div class="body flex-grow-1 px-1">
    <c-container breakpoint="xxl" class="h-auto">
      <router-outlet></router-outlet>
    </c-container>
  </div>
</div>
</ng-container>
<ng-container *ngIf="!api.loading_les_droits && !this.api.infos.agent">
  <div class="text-center m-5 p-5">Erreur de chargement des données de l'agent</div>
</ng-container>
<ng-container *ngIf="api.loading_les_droits && !this.api.infos.agent">
  <div class="loader-wrapper">
    <span class="loader"></span>
  </div>
</ng-container>